import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var KpiChartHeader = function KpiChartHeader(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
};
/**
 * PropTypes Validation
 */


var node = PropTypes.node,
    string = PropTypes.string;
KpiChartHeader.propTypes = {
  children: node,
  className: string
};
/**
 * Default props
 */

KpiChartHeader.defaultProps = {
  children: null,
  className: ''
};
export default styled(KpiChartHeader).withConfig({
  displayName: "Header",
  componentId: "sc-1yl8obx-0"
})(["display:flex;justify-content:space-between;align-items:center;"]);